"use strict";

var Klass = function () {};

module.exports = function create(proto) {
    Klass.prototype = proto;
    return new Klass();
};



/** WEBPACK FOOTER **
 ** ./~/sinon/lib/sinon/util/core/create.js
 **/